import { createFileRoute, redirect } from '@tanstack/react-router'
import { startOfDay } from 'date-fns'
import { parse } from 'valibot'

import {
  fetchContracts,
  type FetchContractsQuery
} from '@/features/contracts/api'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'
import { ContractsSearchSchema } from '@/routes/_protected/$tenantKey/settings/contracts/-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/contracts/'
)({
  validateSearch: (search) => parse(ContractsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    // クエリの有無で初回アクセスかどうかを判定
    const keys = Object.keys(search)

    // 初回アクセス（クエリが空）の場合は、選択中のDCと isApplying=true を既定付与
    if (keys.length === 0) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId,
          isApplying: true,
          operatingDate: startOfDay(new Date()).toISOString()
        }
      })
    }

    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    const query: FetchContractsQuery = {
      tenantKey,
      query: deps
    }
    return {
      authUser: auth.user,
      contracts: await fetchContracts(query, abortController.signal)
    }
  }
})
